import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import styled from 'styled-components';

const StyledTableCell = styled(TableCell)`
  font-weight: bold;
  color: black;
  font-size: 1rem;
`;

class TableHeader extends React.PureComponent {
  render() {
    return (
      <TableHead>
        <TableRow>
          <StyledTableCell>Numéro de la question</StyledTableCell>
          <StyledTableCell>Intitulé de la question FR</StyledTableCell>
          <StyledTableCell>Intitulé de la question DZ</StyledTableCell>
          <StyledTableCell>Réponse</StyledTableCell>
          <StyledTableCell>Intitulé de la réponse FR</StyledTableCell>
          <StyledTableCell>Intitulé de la réponse DZ</StyledTableCell>
          <StyledTableCell>Bonne réponse ?</StyledTableCell>
          <StyledTableCell>Joker utilisé ?</StyledTableCell>
        </TableRow>
      </TableHead>
    );
  }
}
export default TableHeader;
